import { Component } from '@angular/core';
import { CommunityService } from '@common/services/community.service';
import { ContentService } from '@common/services/content.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: false
})

export class FooterComponent {
    year = new Date().getFullYear();
    get communityCode() { return this.communityService.communityCode; }

    constructor(
        public contentService: ContentService,
        private communityService: CommunityService
    ) { }
}